import { useNavigate, useSearchParams } from 'react-router-dom';
import { Typography, Box, Button, Pagination } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useListFavoritesQuery } from '../features/api/rest/apiFavoritesSlice';
import FavoriteProduct from './FavoriteProduct';

function FavoriteProductList() {
  const [searchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page'), 10) || 1;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { favorites, favoritesCount, isSuccess } = useListFavoritesQuery(
    {
      page: currentPage,
    },
    {
      selectFromResult: (result) => ({
        ...result,
        favorites: result.data?.results,
        favoritesCount: result.data?.count,
      }),
      refetchOnMountOrArgChange: true,
    }
  );

  const handleReturn = () => {
    navigate('/');
  };

  const handlePageChange = (nextPage) => {
    navigate(`/profile/favorites?page=${nextPage}`);
  };

  const pagination = favoritesCount > 10 && <Pagination sx={{ my: 2 }} count={Math.ceil(favoritesCount / 10)} page={currentPage} onChange={(event, newPage) => handlePageChange(newPage)} />;

  return (
    favorites &&
    isSuccess && (
      <>
        <Typography variant="h5">{t('products.research.found', { count: parseInt(favoritesCount, 10) })}</Typography>
        <Box>
          <Button variant="contained" onClick={handleReturn} sx={{ mt: 3 }}>
            {t('products.research.form.placeholder')}
          </Button>
          {pagination}
          <section id="Products__Grid">
            {favorites &&
              favorites.map((product) => (
                <FavoriteProduct
                  ean={product.ean_code} // eslint-disable-line no-underscore-dangle
                  key={product.ean_code} // eslint-disable-line no-underscore-dangle
                  favorite={product.favorite}
                />
              ))}
          </section>
          {pagination}
        </Box>
      </>
    )
  );
}

export default FavoriteProductList;
